import { dateToDMY, isLocaleSameDay } from "@api";
import { formatDateWithOptionalTime } from "./formatDateWithOptionalTime";

/** Formats a date range. Same day → single date; different days → "start - end". */
export const formatDateRange = (startDate: Date, endDate: Date, timeZone: string): string => {
  if (isLocaleSameDay(startDate, endDate, timeZone)) {
    return formatDateWithOptionalTime(startDate, { includeTime: true }, timeZone);
  }
  return `${dateToDMY(startDate, timeZone)} - ${dateToDMY(endDate, timeZone)}`;
};
